import React from 'react';
import T from 'prop-types';

const AdvanceEngineeringIcon = (props) => (
	<svg {...props} className={props.className}>
		<path
			d='M8.25 17.75H15.75V16.25H8.25V17.75ZM8.25 13.75H15.75V12.25H8.25V13.75ZM6.3077 21.5C5.80257 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V4.3077C4.5 3.80257 4.675 3.375 5.025 3.025C5.375 2.675 5.80257 2.5 6.3077 2.5H14.25L19.5 7.74995V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6922 21.5H6.3077ZM13.5 8.49995V3.99998H6.3077C6.23077 3.99998 6.16024 4.03203 6.09612 4.09613C6.03202 4.16024 5.99997 4.23077 5.99997 4.3077V19.6923C5.99997 19.7692 6.03202 19.8397 6.09612 19.9038C6.16024 19.9679 6.23077 20 6.3077 20H17.6922C17.7692 20 17.8397 19.9679 17.9038 19.9038C17.9679 19.8397 18 19.7692 18 19.6923V8.49995H13.5Z'
			fill='#6C7DDF'
		/>
	</svg>
);

AdvanceEngineeringIcon.defaultProps = {
	fill: 'none',
	width: 24,
	height: 24,
	viewBox: '0 0 24 24',
};

AdvanceEngineeringIcon.propTypes = {
	className: T.string,
};

export default AdvanceEngineeringIcon;
